import React, { FC, useState } from "react";
import { Button } from "primereact/button";
import { ComplianceSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Section9Props {
  data: ComplianceSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section9: FC<Section9Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div style={{ width: "100%", background: "linear-gradient(180deg, #fff7ed 0%, #f8fafc 100%)", padding: "3rem 1.25rem" }}>
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#9a3412", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>
              Optional Page
            </div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>
              Compliance
            </div>
            <div style={{ color: "#64748b", marginTop: "0.65rem", lineHeight: 1.7, maxWidth: "760px" }}>
              Add a dedicated page for Washington adult family home licensing, certifications, training, nurse delegation, and compliance-focused trust signals.
            </div>
          </div>
          <Button label="Edit Compliance Page" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>

        <div className="grid">
          <div className="col-12 lg:col-7">
            <div style={{ background: "#ffffff", border: "1px solid #f0dcc2", borderRadius: "28px", padding: "1.5rem", height: "100%", boxShadow: "0 18px 38px rgba(180,83,9,0.08)" }}>
              <div className="flex justify-content-between align-items-start gap-3 flex-wrap">
                <div>
                  <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#0f172a" }}>{data?.title || "Licensing, certifications, and compliance"}</div>
                  <div style={{ color: "#64748b", lineHeight: 1.7, marginTop: "0.75rem" }}>{data?.description}</div>
                </div>
                <span style={{ display: "inline-flex", alignItems: "center", borderRadius: "999px", padding: "0.45rem 0.85rem", background: data?.enabled ? "#ecfdf3" : "#fef2f2", color: data?.enabled ? "#047857" : "#b91c1c", fontWeight: 700 }}>
                  {data?.enabled ? "Page enabled" : "Page hidden"}
                </span>
              </div>

              <div className="grid mt-3">
                <div className="col-12 md:col-6">
                  <div style={{ background: "#fffaf3", border: "1px solid #f0dcc2", borderRadius: "22px", padding: "1rem", height: "100%" }}>
                    <div style={{ color: "#b45309", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>License</div>
                    <div className="mt-2" style={{ color: "#6c4b22", lineHeight: 1.8 }}>
                      <div><strong>Number:</strong> {data?.licenseNumber || "Add your license number"}</div>
                      <div><strong>Status:</strong> {data?.licenseStatus || "Active"}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div style={{ background: "#f8fbff", border: "1px solid #dbe7f3", borderRadius: "22px", padding: "1rem", height: "100%" }}>
                    <div style={{ color: "#185da2", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Delegation and medication</div>
                    <div className="mt-2" style={{ color: "#36546c", lineHeight: 1.8 }}>
                      <div><strong>Nurse delegation:</strong> {data?.nurseDelegationSupport || "Add nurse delegation details"}</div>
                      <div className="mt-2"><strong>Medication support:</strong> {data?.medicationManagementSupport || "Add medication support details"}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid mt-2">
                <div className="col-12 md:col-6">
                  <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "22px", padding: "1rem" }}>
                    <div style={{ color: "#0f172a", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Certifications</div>
                    <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.8, color: "#475569" }}>
                      {(data?.certifications || []).map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
                    </ul>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div style={{ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "22px", padding: "1rem" }}>
                    <div style={{ color: "#0f172a", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>Training highlights</div>
                    <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.8, color: "#475569" }}>
                      {(data?.trainingHighlights || []).map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 lg:col-5">
            <div style={{ background: "#ffffff", border: "1px solid #f0dcc2", borderRadius: "28px", padding: "1.5rem", boxShadow: "0 18px 38px rgba(180,83,9,0.08)", height: "100%" }}>
              <div style={{ color: "#0f172a", fontWeight: 800, fontSize: "1.1rem" }}>Compliance summary</div>
              <div style={{ color: "#475569", lineHeight: 1.8, marginTop: "0.85rem" }}>{data?.complianceNotes}</div>
              <div style={{ marginTop: "1rem", paddingTop: "1rem", borderTop: "1px solid #f3e8d3", color: "#64748b", lineHeight: 1.8 }}>
                <strong style={{ color: "#0f172a" }}>Background checks and team readiness:</strong>
                <div className="mt-2">{data?.backgroundCheckSummary}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section9;
